var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{staticClass:"col-lg-6 offset-lg-3 col-sm-12"},[_c('div',[_c('p',{staticClass:"lead text-center"},[_vm._v("You have been logged out. Thank you.")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }